<template>
  <div class="treeNode">
    <Icon
      v-if="data.children && data.children.length"
      style="cursor: pointer"
      :type="data.expand ? 'ios-arrow-down' : 'ios-arrow-forward'"
      @click="expand"
    />
    <Icon v-else style="width: 12px"></Icon>

    <Checkbox
      :disabled="data.disabled ? true : false"
      :value="value.includes(data.value)"
      :size="size"
      v-if="
        (parentNodeAllow && !data.disable) ||
        (!parentNodeAllow && (!data.children || !data.children.length))
      "
      @click.native.prevent="check"
    ></Checkbox>
    <span :class="data.status==1?'dian':'red'" v-if="data.status"></span>
    <span v-html="addMarking(data.label)"></span>
    <treeNode
      v-show="data.expand"
      v-for="(item, index) in data.children"
      :key="index"
      :treeData="treeData"
      :data="item"
      :size="size"
      :value="value"
      :multiple="multiple"
      :selectAllChildren="selectAllChildren ? selectAllChildren : false"
      :parentNodeAllow="parentNodeAllow"
      :keyWord="keyWord"
    />
  </div>
</template>

<script>
export default {
  name: "TreeNode",
  props: [
    "data",
    "size",
    "value",
    "multiple",
    "parentNodeAllow",
    "keyWord",
    "treeData",
    "selectAllChildren",
  ],
  data() {
    return {
      values: [],
    };
  },
  mounted() {
    // console.log(this.value);
    // console.log(this.data.value)
  },
  methods: {
    expand() {
      if (Object.keys(this.data).includes("expand")) {
        this.data.expand = !this.data.expand;
      } else {
        this.$set(this.data, "expand", !this.data.expand);
      }
    },
    //选中子机构
    getValues(datas) {
      for (var i in datas) {
        if (!this.value.includes(datas[i].value)) {
          this.values.push(datas[i].value);
        }
        if (datas[i].children && datas[i].children.length > 0) {
          this.getValues(datas[i].children);
        }
      }
    },
    check() {
      let value = this.data.value;
      let index = this.value.indexOf(value);
      if (index > -1) {
        this.value.splice(index, 1);
      } else {
        !this.multiple && this.value.splice(0, this.value.length);
        this.value.push(value);
        if (this.selectAllChildren) {
          this.values = [];
          //添加所有子id
          if (this.data.children && this.data.children.length > 0) {
            this.getValues(this.data.children);
          }
          this.value.push.apply(this.value, this.values);
        }
      }

      // if (this.multiple) {
      //   if (index > -1 && this.data.children && this.data.children.length) {
      //     this.remove(this.data.children);
      //   } else if (this.data.children && this.data.children.length) {
      //     this.add(this.data.children);
      //   }
      //   if (typeof this.data._value === "string") {
      //     let parents = this.data._value.split("/");
      //     parents.pop();
      //     if (index > -1) {
      //       parents.forEach(item => {
      //         let index = this.value.indexOf(item);
      //         if (index > -1) {
      //           this.value.splice(index, 1);
      //         }
      //       });
      //     } else {
      //       this.addParents(parents);
      //     }
      //   }
      // }
    },
    addMarking(html) {
      return this.keyWord
        ? html
            .split(this.keyWord)
            .join(`<font color="red">${this.keyWord}</font>`)
        : html;
    },
    addParents(data) {
      while (data.length) {
        let parent = data.pop();
        let parentNode = this.getParentNode(parent);
        if (
          parentNode &&
          parentNode.children.every((item) => this.value.includes(item.value))
        ) {
          this.value.push(parent);
        }
      }
    },
    getParentNode(value) {
      let res;
      (function loop(data) {
        for (let i = 0, len = data.length; i < len; i++) {
          if (data[i].value === value) {
            res = data[i];
            break;
          } else if (!res && data[i].children && data[i].children.length) {
            loop(data[i].children);
          }
        }
      })(this.treeData);
      return res;
    },
    remove(data) {
      data.forEach((item) => {
        let index = this.value.indexOf(item.value);
        if (index > -1) {
          this.value.splice(index, 1);
        } else {
          this.value.push(item.value);
        }
        if (item.children && item.children.length) {
          this.remove(item.children);
        }
      });
    },
    add(data) {
      data.forEach((item) => {
        let index = this.value.indexOf(item.value);
        if (index === -1) {
          this.value.push(item.value);
        }
        if (item.children && item.children.length) {
          this.add(item.children);
        }
      });
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
.treeNode {
  padding-left: 18px;
  .dian {
    display: inline-block;
    margin-bottom: 2px;
    width: 5px;
    height: 5px;
    background: #35BF3F;
    border-radius: 50%;
  }
  .red {
    display: inline-block;
    margin-bottom: 2px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #E3461F;
  }
}
</style>
